<template>
  <!--新增服务人员账号-->
  <el-dialog title="账号授权" :visible.sync="isShowAuth" width="30%" :destroy-on-close="true" @close="$emit('update:show',false)">
    <el-form ref="ruleForm" :model="account" class="dialog-form">
      <el-form-item label="账号" :label-width="formLabelWidth" prop="account">
        <span>{{ account.account || '-' }}</span>
      </el-form-item>
      <el-form-item label="关联OA账号" :label-width="formLabelWidth" prop="customer_number">
        <span>{{ account.customer_number || '-' }}</span>
      </el-form-item>
      <el-form-item label="使用者昵称" :label-width="formLabelWidth" prop="real_name">
        <span>{{ account.real_name || '-' }}</span>
      </el-form-item>
      <el-form-item v-if="isShowAuth" label="角色" :label-width="formLabelWidth" prop="roles">
        <el-tree
          ref="tree"
          :data="allRoles"
          :props="treeProps"
          show-checkbox
          node-key="id"
          :default-checked-keys="account.roles"
          @check-change="handleCheckChange"
        />
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="$emit('update:show', false)">取 消</el-button>
      <el-button type="primary" :loading="loading" @click="onSubmit('ruleForm')">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import _ from 'lodash'
import {
  updateAdminAccount
} from '@/api/adminAccount'
import { fetchUserRole } from '@/api/role'
import { RES_SUCCESS_CODE } from '@/constances/server'
export default {
  props: {
    show: {
      type: Boolean,
      default: false
    },

    accountInfo: {
      type: Object,
      default() {
        return {}
      }
    },

    platformIds: {
      type: Array,
      default() {
        return []
      }
    }
  },

  data() {
    return {
      loading: false,
      remoteLoading: false,
      isShowAuth: this.show, // 打开密码修改
      account: { // 当前选中账号信息
        account: '',
        name: '',
        role_id: '',
        platform_ids: [],
        store_id: undefined
      },
      formLabelWidth: '100',
      treeProps: {
        label: 'name',
        children: 'children'
      },
      allRoles: [],
      roles: []
    }
  },

  watch: {
    accountInfo(n) {
      this.account = {
        ...n,
        roles: n.roles ? n.roles.map(item => item.id) : []
      }
    },
    show(n) {
      this.isShowAuth = n
    }
  },

  created() {
    this.getRoles()
  },

  methods: {
    handleChangeRole(value) {
      console.log(value)
    },
    handleCheckChange(data, checked, indeterminate) {
      console.log(data, checked, indeterminate)
      if (checked) {
        // this.$refs.tree.setCheckedKeys([data, 3])
        const values = this.$refs.tree.getCheckedNodes(true).map(item => item.id)
        const role = this.roles.filter(item => item.id === data.id)[0] || {}
        const platform_id = role.platform_id
        console.log('==role', role, platform_id)
        const bro = this.roles.filter(item => item.platform_id === platform_id && item.id !== data.id).map(item => item.id)
        const _values = values.filter(item => !bro.includes(item))
        console.log(values, bro, _values)
        this.$refs.tree.setCheckedKeys(_values)
      }
    },
    getCheckedNodes() {
      return this.$refs.tree.getCheckedNodes(false, true)
    },
    // 获取菜单
    getRoles() {
      this.loading = true
      fetchUserRole({
        status: 1,
        platform_ids: this.platformIds.join(','),
        page_size: 9999
      }).then(res => {
        this.loading = false
        if (res && res.code === RES_SUCCESS_CODE) {
          const options = []
          const platforms = []
          this.roles = res.data.list
          res.data.list.filter(role => {
            return role.name.indexOf('CMS门店') === -1  // 应该后端隐藏
          }).map(item => {
            if (platforms.includes(item.platform_id)) {
              const platform = options.filter(opt => opt.id === 'platform_' + item.platform_id)[0]
              platform.children.push({
                id: item.id,
                name: item.name
              })
            } else {
              options.push({
                id: 'platform_' + item.platform_id,
                name: _.get(item, ['platform', 'platform_name']),
                disabled: true,
                children: [{
                  id: item.id,
                  name: item.name
                }]
              })

              platforms.push(item.platform_id)
            }
          })
          this.allRoles = options
        }
      })
    },
    onSubmit(name) {
      this.$refs[name].validate(valid => {
        if (valid) {
          const payload = {
            roles: this.$refs.tree.getCheckedNodes(true).map(item => item.id)
          }
          this.loading = true
          updateAdminAccount(this.account.id, payload).then(response => {
            // 关闭弹层
            this.$emit('update:show', false)
            // 更新数据
            this.$emit('updateInfo', response.data)
            this.$message({
              message: '更新授权信息成功',
              type: 'success',
              duration: 3 * 1000
            })
          }).finally(() => {
            this.loading = false
          })
        }
      })
    }
  }

}
</script>

<style lang="scss" scoped>
  @import '../../styles/dialog-form.scss';
</style>
